import { createContext } from "react";

const LayoutContext = createContext({
  renderBar: "",
  setRenderBar: () => {},
  modalProp: {},
  setModalProp: () => {},
});

export default LayoutContext;
